 import { useTranslation } from "react-i18next";
 const SalesBarChart = ({ data }) => {
    const { t } = useTranslation();

    return (
        <div className="Chart_Div" style={{ overflowX: "hidden" }} >
            <div className="Chart_Title">{t("SALES_BY_USERS")}</div>
            {data.USER_SALES?.length > 0 && (
                <div>
                    {data.USER_SALES?.map((key, index) => {
                        const salesPercentage = key.TOTAL_SALES ? (key.TOTAL_SALES / 10000000) * 100 : 0;

                        return (
                            <div key={index}>
                                <div
                                    style={{
                                        display: "flex", width: "100%", alignItems: "center"
                                    }}>

                                    {!key.IMAGE_URL && (
                                        <span className="TitleImg">
                                            {key.USER_NAME.substring(0, 2).toUpperCase()}
                                        </span>
                                    )}

                                    <div className="Chart_Title_Name" style={{ margin: "15px 0", width: "100%" }}>
                                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                            {key.USER_NAME}
                                            <sub className="Chart_Title_Name_Branch">{key.BRANCH_NAME}
                                            </sub>
                                        </div>
                                        <div className="Chart">
                                            <div
                                                className="Chart_Fill"
                                                style={{
                                                    width: `${salesPercentage}%`,
                                                }}
                                            ></div>
                                        </div>

                                        <div className="Chart_Subtitle">
                                            {key.TOTAL_SALES ? key.TOTAL_SALES.toLocaleString() : "0"}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default SalesBarChart;




